import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Flex,
  Text,
  Box,
  IconButton,
  Image,
} from "@chakra-ui/react";
import { CloseIcon, ExternalLinkIcon, LinkIcon } from "@chakra-ui/icons";
import { useMainChatContext } from "@root/context/kps-chat-context";
import ProjectsListing from "@root/components/dashboard/ProjectsListing";
import ChatSources from "./ChatSources";

const ChatRightPanel = () => {
  const {
    openProjectsListing,
    sourcesData,
    setOpenProjectsListing,
    setSourcesData,
  } = useMainChatContext();

  const isPanelVisible = openProjectsListing || sourcesData;

  const onClose = () => {
    setOpenProjectsListing(false);
    setSourcesData(null);
  };

  function renderContent() {
    if (openProjectsListing) return <ProjectsListing />;
    if (sourcesData) return <ChatSources />;
    return null;
  }

  return (
    <Drawer
      isOpen={!!isPanelVisible}
      placement="right"
      onClose={onClose}
      size="sm"
    >
      <DrawerOverlay />
      <DrawerContent bg="white" borderLeft="1px solid #CDD6DC" boxShadow="xl">
        {renderContent()}
      </DrawerContent>
    </Drawer>
  );
};

export default ChatRightPanel;
